import { render, staticRenderFns } from "./LayoutTimeTotals.vue?vue&type=template&id=9037e4ca&"
import script from "./LayoutTimeTotals.vue?vue&type=script&lang=ts&"
export * from "./LayoutTimeTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports